import type { JSX, ReactNode, HTMLAttributes } from 'react';
import { styled } from 'styled-components';

const StyledTableRow = styled.tr`
  width: 100%;
`;

export type TableRowProps = HTMLAttributes<HTMLTableRowElement> & {
  children?: ReactNode;
};

export const TableRow = ({ children, ...props }: TableRowProps): JSX.Element => {
  return <StyledTableRow {...props}>{children}</StyledTableRow>;
};
